module.exports = __webpack_public_path__ + "img/austin_vxnyub.9e49c449.png";